import { ButtonHeaderComponent } from './button-header.component';

export default angular
  .module('sfMobile.components.button-header', [])
  .component('sfButtonHeader', ButtonHeaderComponent).name;
